import { render, staticRenderFns } from "./taskDetailDialog.vue?vue&type=template&id=06d755b8&scoped=true&"
import script from "./taskDetailDialog.vue?vue&type=script&lang=js&"
export * from "./taskDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./taskDetailDialog.vue?vue&type=style&index=0&id=06d755b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d755b8",
  null
  
)

export default component.exports